import { createApp } from 'vue'

import i18n from './lang' // internationalization

import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'

import './assets/styles/index.scss' // global css

import App from '@/App.vue'
import Router from "@/router"
import store from './store'

import '@/config/permission' // permission control

import titleMixin from './utils/titleMixin'

const app = createApp(App)
app.mixin(titleMixin).use(Router).use(store).use(ElementPlus, { i18n: i18n.global.t, }).use(i18n).mount("#app")
